const universalRoomOptions = {
  hideNavigation: {
    label: 'Hide Navigation',
    type: 'bool',
    value: false
  },
  hideRoomCode: {
    label: 'Hide Room Code',
    type: 'bool',
    value: false
  },
  roomCodeType: {
    label: 'Room Code Type ',
    type: 'select',
    value: 'text',
    options: [
      {
        label: 'Text',
        value: 'text'
      },
      {
        label: 'QR Code',
        value: 'qrCode'
      }
      // {
      //   label: 'QR Code with Text',
      //   value: 'both'
      // }
    ]
  }
}

type Activities = Record<string, Activity>

interface Activity {
  active: boolean
  name: string
  slug: string
  key: string
  recommendedSize: string
  minPlayers: number
  maxPlayers: number
  categories: string[]
  description: string[]
  hostInfo: string[]
  audienceInfo: string[]
  emojis: string
  version: string
  patchNotes: Array<{ date: string; notes: string }>
  roadmap: string[]
}

const activities: Activities = {
  spaceAceBlightClub: {
    active: true,
    name: 'Space Ace Blight Club',
    slug: 'space-ace-blight-club',
    key: 'spaceAceBlightClub',
    recommendedSize: '1',
    minPlayers: 1,
    maxPlayers: 1,
    categories: ['Fun', 'Video', 'Weird'],
    hostInfo: [
      "Use on-screen buttons or your keyboard's arrow keys to navigate"
    ],
    audienceInfo: [],
    description: [
      'Play a "Space Ace" style FMV game of Giant Bomb\'s Dan Ryckert playing the SNES version of Space Ace'
    ],
    emojis: '🔫🧑‍🚀💣',

    version: '1.0.0',
    patchNotes: [
      {
        date: '2026-07-12',
        notes: 'Initial Push Live'
      }
    ],

    roadmap: []
  },
  megamanPuzzleAdventure: {
    active: true,
    name: "Mega Man's Puzzle Adventure",
    slug: 'megaman-puzzle-adventure',
    key: 'megamanPuzzleAdventure',
    recommendedSize: '1',
    minPlayers: 1,
    maxPlayers: 1,
    categories: ['Fun', 'Weird', 'Emulation'],
    hostInfo: [
      "Use on-screen buttons or your keyboard's arrow keys to navigate"
    ],
    audienceInfo: [],
    description: [
      'Play Mega Man 3 while also playing a match 3 puzzle game to refill your weapon energy',
      '**Note: This activity requires a rom of Mega Man 3. (Not Provided) **'
    ],
    emojis: '🤖🧩🎮',

    version: '0.0.3',
    patchNotes: [
      {
        date: '2026-07-12',
        notes: 'Initial Push Live'
      }
    ],

    roadmap: []
  },
  pragmataMan: {
    active: true,
    name: 'Pragmata Man',
    slug: 'pragmata-man',
    key: 'pragmataMan',
    recommendedSize: '1',
    minPlayers: 1,
    maxPlayers: 1,
    categories: ['Fun', 'Weird', 'Emulation'],
    hostInfo: [
      "Use on-screen buttons or your keyboard's arrow keys to navigate"
    ],
    audienceInfo: [],
    description: [
      "A Mega Man 3 & Pragamata Mash up. Play a hacking mini game to remove the enemy's shields",
      '**Note: This activity requires a rom of Mega Man 3. (Not Provided) **'
    ],
    emojis: '🧑‍🚀👧🎮',

    version: '0.6.3',
    patchNotes: [
      {
        date: '2026-05-04',
        notes: 'Initial Push Live'
      }
    ],

    roadmap: []
  },
  videoArmageddon: {
    active: true,
    name: 'Video Armageddon',
    slug: 'video-armageddon',
    key: 'videoArmageddon',
    recommendedSize: '3-89',
    minPlayers: 3,
    maxPlayers: 89,
    categories: ['Competitive', 'Retro', 'Experimental'],
    description: [
      'Race up to 89 players to get the highest score in Super Mario Bros 3 before the time runs out.',
      '**Note: This activity requires a rom of Super Mario Bros 3. (Not Provided) **',
      'Music by Patricia Taxxon - Wavetable from the album of the same name. \n\n Used with permission. https://patriciataxxon.bandcamp.com/album/wavetable'
    ],
    hostInfo: [
      'Let your players know in advanced that they will need a rom of Super Mario Bros 3.',
      'From the settings menu (☰) select the options you want to use for the game.',
      'Click Start once everyone has joined the room.'
    ],
    audienceInfo: [
      'Visit Reactvts.com/Join to get instructions on how to join using our custom Bizhawk Emulator',
      '(Sorry, We cannot provide the rom)'
    ],
    emojis: '🍄🌴🎮',
    version: '1.9.1.7',

    patchNotes: [
      {
        date: '2026-09-05',
        notes:
          'Migrated to ittysocket and made everything playable in the browser'
      },
      {
        date: '2025-07-27',
        notes: 'Updated to latest version of Pixijs'
      },
      {
        date: '2024-04-11',
        notes:
          'Major lobby rework and other bug fixes\n\n full patch notes on the git repo'
      },
      {
        date: '2024-04-01',
        notes: `Updated item effects\n\n
          Increased player count to 89`
      },
      {
        date: '2024-03-23',
        notes:
          'Added buying and firing items (Bizhawk only), updated music and sounds'
      },
      {
        date: '2024-02-28',
        notes: 'Added web browser alternative emulator'
      },
      {
        date: '2024-02-25',
        notes:
          'Moved away from bridge application and now leveraging Bizhawk with WSS enabled. Also added timer, music and sounds, and Win Screen'
      },
      {
        date: '2024-02-17',
        notes: 'Beta Launch'
      }
    ],
    roadmap: [
      'Add sounds & animations for when the player dies or hits the "Warp Zone"'
    ]
  },
  playalong: {
    active: true,
    name: 'Playalong',
    slug: 'playalong',
    key: 'playalong',
    recommendedSize: '1-20',
    minPlayers: 1,
    maxPlayers: 20,
    categories: ['Social', 'Competitive', 'Guessing'],
    description: [
      'Watch Shows And Guess Trivia Prompts As It Appears On The Screen.',
      'All videos are the property of the original artist and should not be reuploaded or used on stream without permission.',
      'If you are the original creator and would like your videos removed, please contact me at info@reactvts.com',
      'Social Share image by Kevin Malik from Pexels'
    ],
    hostInfo: [
      'Pick An Available Video.',
      'Click ☰ for more options.',
      'Watch Along With Your Friends And Guess The Trivia Questions As They Appear On The Screen.'
    ],
    audienceInfo: [
      'Use Your Phone Or Computer Browser To Join The Room And Play The Game.',
      'Watch The Video And Answer The Trivia Questions As They Appear On The Screen.'
    ],
    emojis: '📺💬📱',
    version: '1.0.0.7',

    patchNotes: [
      {
        date: '2025-07-13',
        notes: 'Added Leet Heat S1E11'
      },
      {
        date: '2025-06-28',
        notes:
          "Added The Gotta Catch 'Em All Game Show with Briand David Gilbert"
      },
      {
        date: '2025-04-23',
        notes: 'Added Leet Heat S1E6'
      },
      {
        date: '2025-04-09',
        notes: 'Added Leet Heat S1E4'
      },
      {
        date: '2025-03-04',
        notes: 'Added Leet Heat S1E3'
      },
      {
        date: '2025-02-28',
        notes: "Added Tie Tuesday's Name That Tune Episode 1"
      },
      {
        date: '2025-02-21',
        notes:
          'Added Game Showdown Season 3 Episode 5, Web Dev Guessing Game Episode 2, MBMBAM clubhouse, and minor fixes'
      },
      {
        date: '2025-02-13',
        notes:
          '1.0 Release of main site, Beta release of Playalong Builder tool'
      },
      {
        date: '2025-02-07',
        notes: 'added KFGS 3'
      },
      {
        date: '2025-02-01',
        notes: 'Added Kinda funny game showdown '
      },

      {
        date: '2025-01-28',
        notes:
          'Added Um Actually Season 2 Episode 2, added volume and settings buttons on screen'
      },
      {
        date: '2025-01-27',
        notes:
          'Added FGST Holiday Matsuri 2024 episode & Syntax Web Dev Guessing Game episode, also added volume buttons'
      },
      {
        date: '2025-01-26',
        notes: 'Added two Kinda Funny Games Showdown episodes'
      },
      {
        date: '2025-01-25',
        notes:
          'Added Leet Heat S1E2 & Mcelroy Family Club House episodes, continued work on builder tool and started work on twitch support'
      },
      {
        date: '2025-01-19',
        notes: 'Added Mobile Solo play mode.'
      },
      {
        date: '2025-01-12',
        notes:
          'Added Hank Green\'s Real or Fake Tweets, added video trailer to homepage and "too small" modal'
      },
      {
        date: '2025-01-10',
        notes:
          'Added Dirty Laundry S4E3, added ability to go back and for between prompts and results'
      },
      {
        date: '2025-01-09',
        notes:
          'Added Gaming Quiz Time with the audience - session 1, UX improvements for Builder tool (coming soon)'
      },
      {
        date: '2025-01-06',
        notes:
          'Added youtube as intro and prompt music source, added sepratevolume control for music and main video, added tab in playlong-builder to set music source and start and end time, better music support and looping, and added Leet Heat Episode 1'
      },
      {
        date: '2025-01-02',
        notes: 'Cleaned up styles'
      },
      {
        date: '2025-01-01',
        notes: 'Started work on Live Play, added feud style question type'
      },
      {
        date: '2024-12-15',
        notes:
          'Fixed bug with quickresults score miscalculating, added end screen for join view, made full vidoe visible on pause, join view now shows score. Added delay option for streams with delay like twitch'
      },
      {
        date: '2024-12-12',
        notes: 'Updated episode list'
      },
      {
        date: '2024-12-12',
        notes: 'Added better social media share previews'
      },
      {
        date: '2024-12-10',
        notes:
          'Added Um Actually Season 2 Episode 19: Ho Ho Ho, Actually: The Holiday Special'
      },
      {
        date: '2024-12-09',
        notes:
          'Added Um Actually Season 5 Episode 23 (Holiday Special), also fixed "Order" showing letters instead of numbers, and fixed quickResults to show cumalitive score on next full results'
      },
      {
        date: '2024-11-27',
        notes: 'Added Um Actually Season 2 Episode 1'
      },
      {
        date: '2024-11-21',
        notes:
          'Added Halloween 2024 Arcade Pit and Initial Push of Episode Builder at reactvts.com/playong-builder'
      },
      {
        date: '2024-11-1',
        notes:
          'Added show length and number of questions to episode list, also add first epiosde of MinnMax Trivia Tower'
      },
      {
        date: '2024-11-09',
        notes:
          'Added fully automatic playthrough options chooseable in the settings,Simplified controls, \nmultiple choice promps are just buttons now instead of typing. \nOther minors fixes to layouts'
      },
      {
        date: '2024-11-08',
        notes:
          'Better episode selection and now you can link directly to the show you want to watch'
      },
      {
        date: '2024-11-08',
        notes:
          'Added ability to watch and play on the same screen on large desktop screen (check options)'
      },
      {
        date: '2024-11-07',
        notes:
          'Added another episode of "Dirty Laundry & removed !guess for mobile users"'
      },
      {
        date: '2024-11-07',
        notes: 'Fixed Description'
      },
      {
        date: '2024-11-06',
        notes: 'Initial Release'
      }
    ],
    roadmap: ['Add more shows', 'Add better game reset options']
  },
  foggyGolf: {
    active: true,
    name: 'Foggy Golf',
    slug: 'https://foggy.golf/',
    key: 'foggyGolf',
    recommendedSize: '1',
    minPlayers: 1,
    maxPlayers: 1,
    categories: ['One a Day Puzzle', 'Wordle-Like'],
    description: [
      "Reach the hole in as few strokes as possible, but it's too foggy to see. New holes daily!"
    ],
    hostInfo: [],
    audienceInfo: [],
    emojis: '🏌️☁️⛳',
    version: '1.1.3',

    patchNotes: [],
    roadmap: ['Add other retro console games', 'Add better game reset options']
  },
  quizetro: {
    active: true,
    name: 'Quizetro',
    slug: 'quizetro',
    key: 'quizetro',
    recommendedSize: '1-4',
    minPlayers: 1,
    maxPlayers: 4,
    categories: ['Trivia', 'Competitive', 'Mixed Media'],
    description: [
      'Play the NES Game "Anticipation" with friends using your device\'s touch controls or keyboard.'
    ],
    hostInfo: [
      'You will have to provide your own rom for the game. We cannot provide it for you.',
      'At the end of the game, to play again, you will need to refresh the page.'
    ],
    audienceInfo: [
      'Use your phone or computer browser to join the room and play the game. No additional software is required.',
      'At the end of the game, to play again, you will need to refresh the page and join the new room code'
    ],
    emojis: '👠📯🧸🍦',
    version: '0.5.0',

    patchNotes: [
      {
        date: '2024-10-26',
        notes: 'Initial Release'
      }
    ],
    roadmap: ['Add other retro console games', 'Add better game reset options']
  },
  emojiMirror: {
    active: true,
    name: 'Emoji Mirror',
    slug: 'emoji-mirror',
    key: 'emojiMirror',
    recommendedSize: '4-25',
    minPlayers: 4,
    maxPlayers: 50,
    categories: ['Icebreakers', 'Team Building', 'Fun'],
    description: [
      'Mimic your assigned emoji while also seeking the other players with the same emoji in this fun group icebreaker.'
    ],
    hostInfo: [
      'Everyone participating must be visible (in person or a video call)',
      'Set the timer to something appropriate for your group or location (In person event may require more time since they may have to move to see everyone)',
      'Everyone has at least 1 mirror (games with odd number of player will have 1 team of 3 matching emojis)',
      'Once the time runs out, the results of who matched with who will be shown on the screen and the audience.'
    ],
    audienceInfo: [
      'Check your device for your emoji to mimic it to the rest of the audience.',
      'Keep acting out your emoji while you look at at everyone for your "mirror."',
      'Enter your guess as to who your mirror is on your device and see if you found your match.',
      'Wait for the timer to run out and see the results on the screen.'
    ],
    emojis: '🤪🤪🤪',

    version: '0.1.0',
    patchNotes: [
      {
        date: '2024-02-05',
        notes: 'Added Infobox Tutorial'
      },
      {
        date: '2023-10-17',
        notes: 'Initial Push Live'
      }
    ],
    roadmap: ['UI Design clean up']
  },
  vibeCheck: {
    active: true,
    name: 'Emoji Vibe Check',
    slug: 'vibe-check',
    key: 'vibeCheck',
    recommendedSize: '5+',
    minPlayers: 5,
    maxPlayers: 30,
    categories: ['Icebreakers', 'Team Building', 'Conflict Resolution'],
    description: [
      'Select and discuss emojis that reflect your mood to foster group atmosphere awareness.'
    ],
    hostInfo: [
      'The audience can select from a variety of emojis to reflect their mood or "vibe" at the moment.',
      'Pick from three types of "Views", Wheel, Donut Graph or Bar Graph, to gage the audience\'s vibe or mood.',
      'Set the Max Count and Leaky Bucket options to control the amount of votes and how often they can be cast.'
    ],
    audienceInfo: [
      'Join the room and click on the emojis that best fit your "vibe"',
      'You can send multiple different or the same emojis to reflect your mood at different times during the session.',
      'The host will be able to see the results and can start a discussion based on the results'
    ],
    emojis: '😃😫😵',

    version: '1.1.0',
    patchNotes: [
      {
        date: '2024-2-05',
        notes: 'Added tutorial infobox'
      },
      {
        date: '2023-10-22',
        notes: 'Added Max Count and Leaky Bucket Options'
      },

      {
        date: '2023-08-19',
        notes: 'Added Sidebar Nav and made style consistent'
      },
      {
        date: '2023-09-09',
        notes: 'Initial Push Live'
      }
    ],
    roadmap: ['Add session restoration']
  },
  fireworks: {
    active: true,
    name: 'Fireworks',
    slug: 'fireworks',
    key: 'fireworks',
    recommendedSize: '2-10',
    minPlayers: 2,
    maxPlayers: 20,
    categories: ['Fun', 'Team Building'],
    description: [
      'Work together as a team to ignite the night sky with a beautiful fireworks display.'
    ],
    emojis: '🎇🎆🎇',

    version: '1.0.0',
    patchNotes: [
      {
        date: '2023-08-19',
        notes: 'Added Sidebar Nav and made style consistent'
      },
      {
        date: '2023-08-07',
        notes: 'Initial patch notes'
      }
    ],
    hostInfo: [
      'Let the audience know to join the room and click on the fireworks to launch them.'
    ],
    audienceInfo: [
      "Join the room and click and click on the fireworks to launch them. That's it!",
      'Have fun and enjoy the show!'
    ],
    roadmap: []
  },
  startStopContinue: {
    active: true,
    name: 'Start Stop Continue',
    slug: 'start-stop-continue',
    key: 'startStopContinue',
    recommendedSize: '2-10',

    minPlayers: 2,
    maxPlayers: 20,
    categories: ['Brainstorming', 'Decision Making', 'Feedback and Evaluation'],
    description: [
      'Share constructive feedback with your team by identifying what should be started, stopped, and continued.'
    ],
    hostInfo: [
      'Audience members can submit their feedback notes in one of three categories, "Start", "Stop" or "Continue"',
      'Click the sticky note to maximize it',
      'Click the trash can in the corner to remove the sticky note from the board',
      'From the menu, click "Export to CSV" to download the feedback to a spreadsheet'
    ],
    audienceInfo: [
      'Join the room using the room code.',
      'From your device, submit your feedback buy typing in the field and then clicking "Start", "Stop" or "Continue"',
      'Once you have submitted your feedback, you can works as a team to review all the sticky notes and discuss them as a group.'
    ],
    emojis: '🟢🔴🟡',

    version: '1.0.0',
    patchNotes: [
      {
        date: '2023-11-26',
        notes: 'Move Room Code to the left to not have yellow on yellow'
      },
      {
        date: '2023-08-19',
        notes: 'Added Sidebar Nav and made style consistent'
      },
      {
        date: '2023-08-07',
        notes: 'Added on click fullscreen & note outline'
      }
    ],
    roadmap: ['Animated columns', 'Variable font size based on character count']
  },
  upForDiscussion: {
    active: true,
    name: '"Up" for Discussion',
    slug: 'up-for-discussion',
    key: 'upForDiscussion',
    categories: ['Brainstorming', 'Decision Making', 'Feedback and Evaluation'],
    recommendedSize: '2-10',
    minPlayers: 2,
    maxPlayers: 20,
    emojis: '🙋🏽‍♀️🙋🏿‍♂️🙋🏻',
    description: [
      'Let the audience propose question or vote "up" the ones they think should answered.'
    ],
    hostInfo: [
      'Questions will be sorted by the number of votes they receive, with the most voted questions at the top of the board.',
      'Clicking on the questions will zoom in to a fullscreen view and allow the audience to see more details and discuss as a group',
      'Clicking on the checkmark to mark it as answered, or the trashcan to remove it from the board',
      'Click on the menu to select options like "Hide Names" or "Show Delete Questions',
      'From the menu, click "Export to CSV" to download the feedback to a spreadsheet'
    ],
    audienceInfo: [
      'Join the room using the room code and view the submitted questions to be upvoted by the rest of the audience.',
      'Toggle the up arrow to vote on the questions you think should be answered.',
      'Submit your own questions to be upvoted by the rest of the audience.'
    ],

    version: '1.1.0',
    patchNotes: [
      {
        date: '2024-02-05',
        notes: 'Added infobox tutorial'
      },
      {
        date: '2023-08-19',
        notes: 'Added Sidebar Nav and made style consistent'
      },
      {
        date: '2023-09-18',
        notes: 'Applied Sticky Notes style to activity'
      },
      {
        date: '2023-08-18',
        notes: 'Added activity options'
      },
      {
        date: '2023-08-09',
        notes: 'Push live'
      },
      {
        date: '2023-08-07',
        notes: 'Added on click fullscreen & note outline'
      }
    ],
    roadmap: ['Session restoration']
  },
  twoTruthsAndALie: {
    active: true,
    name: 'Two Truths and A Lie',
    slug: 'two-truths-and-a-lie',
    key: 'twoTruthsAndALie',
    recommendedSize: '2-10',
    minPlayers: 2,
    maxPlayers: 20,
    categories: ['Fun', 'Icebreakers', 'Team Building'],
    description: [
      'Share three statements about yourself, two true and one lie, challenging others to identify which fact is the fake.'
    ],
    hostInfo: [
      'Let the audience know to join the room and submit their 2 truths and 1 lie.',
      'Click "Start" once everyone has submitted their 2 truths and 1 lie.',
      "Once a audience member's facts are revealed, let the rest of the audience vote on which they believe is the lie.",
      'Click Reveal to show the correct answer and move on to the next person.',
      'Once all the players have gone, click "Play Again" to start a new round.'
    ],
    audienceInfo: [
      'Join the room and and submit your 2 truths and 1 lie.',
      "Once the game has started, wtach the screen two see the current player's facts",
      'Click on the sticky note on your screen that you think is the lie',
      'Once the correct answer is revealed, the next person will go.'
    ],
    emojis: '😇😇🤥',
    version: '1.1.0',
    patchNotes: [
      {
        date: '2024-02-05',
        notes: 'Added infobox tutorial'
      },
      {
        date: '2023-08-19',
        notes: 'Added Sidebar Nav and made style consistent'
      },
      {
        date: '2023-09-02',
        notes: 'Initial Push Live'
      }
    ],
    roadmap: ['Session restoration']
  }
}

interface Activity {
  name: string
  categories: string[]
  recommendedSize: string
  minPlayers: number
  maxPlayers: number
  emojis: string
  description: string[]
  hostInfo: string[]
  audienceInfo: string[]
  slug: string
  version: string
  patchNotes: Array<{
    date: string
    notes: string
  }>
  roadmap: string[]
}

export { universalRoomOptions, activities, type Activity }
